module.exports = __webpack_public_path__ + "img/customLogo.71576d1f.png";